// JavaScript equivalent of Python TextChoices enums
export const SubGalleryDisplayType = {
  LIST: { value: "l", label: 'List' },
  TAB: { value: "t", label: 'Tab' },
  
  // Helper methods
  fromValue(value) {
    return Object.values(this).find(type => 
      typeof type === 'object' && type.value === value
    );
  },
  
  values() {
    return Object.values(this)
      .filter(item => typeof item === 'object')
      .map(item => item.value);
  },
  
  choices() {
    return Object.values(this)
      .filter(item => typeof item === 'object')
      .map(item => [item.value, item.label]);
  }
};

export default SubGalleryDisplayType;